import { j as l } from "./atoms-v218.js";
import { forwardRef as d } from "react";
import { InputOutline as f } from "./atoms-v2703.js";
const m = d(
  ({
    children: t,
    className: e = "",
    colorTheme: i = "light",
    id: s,
    isDisabled: o = !1,
    isErrored: r = !1,
    isFocused: u = !1,
    isGroupedInput: a = !1,
    variant: n = "productive"
  }, p) => /* @__PURE__ */ l.jsx(
    f,
    {
      $colorTheme: i,
      $isDisabled: o,
      $isErrored: r,
      $isFocused: u,
      $isGroupedInput: a,
      $variant: n,
      className: e,
      "data-testid": "input-outline",
      id: s,
      ref: p,
      children: t
    }
  )
);
m.displayName = "InputOutline";
export {
  m as InputOutline
};
